import { useSelector } from 'react-redux';
import { ReactNode } from 'react';
import { useLogger } from '@packages/shared/core/common/hooks';
import { useQuizStep } from '@packages/shared/core/quiz/hooks';
import { getZodiac } from '@packages/shared/core/user/store/selectors';
import { ProblemStepData, QuizScreenProps } from '@packages/shared/core/quiz/entities';

type ProblemQuizStepProps = {
  id: string;
  renderQuizScreen: (stepData: QuizScreenProps) => ReactNode;
};

const ProblemQuizStep = ({ id, renderQuizScreen }: ProblemQuizStepProps) => {
  const logger = useLogger();
  const zodiac = useSelector(getZodiac);

  const { back, next, stepData, updateUserPreferences, userPreferences, totalSteps, stepOrder } = useQuizStep(id);

  if (!stepData) {
    // TODO add fallback
    logger.error(new TypeError(`Data for ${id} step not found`));
    return null;
  }

  const { dataKey, getGoal } = stepData as ProblemStepData;

  const goBack = async () => back();

  const onChosen = async (value: string) => {
    updateUserPreferences(dataKey, value);
    await next();
  };

  const goal = getGoal ? getGoal(userPreferences.goal) : '';

  return (
    <>
      {renderQuizScreen({
        onChosen,
        onBack: goBack,
        userPreferences,
        totalSteps,
        stepOrder,
        zodiac,
        goal,
        ...(stepData as ProblemStepData),
      })}
    </>
  );
};

export default ProblemQuizStep;
